import { render } from "./CodeScreen.vue?vue&type=template&id=286e1dd1&scoped=true"
import script from "./CodeScreen.vue?vue&type=script&lang=js"
export * from "./CodeScreen.vue?vue&type=script&lang=js"

import "./CodeScreen.vue?vue&type=style&index=0&id=286e1dd1&lang=sass&scoped=true"

import exportComponent from "D:\\Open Server 5.3.5\\OSPanel\\domains\\front\\personal_form\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286e1dd1"]])

export default __exports__